import Show from '../../Show/Show';
import { COLORS } from '../../../config/designSystem/Colors';
import { FC} from 'react';
import { Feather } from '@expo/vector-icons';
import { IQuestionModel } from '../../../state/stores/Question/QuestionModel';
import { SnapshotOrInstance } from 'mobx-state-tree';
import { StyleWithBreakpoints, useBreakpointStyles } from '../../../hooks/useBreakpointStyles';
import { TextInput } from 'react-native';
import { TextInput2 } from '../../TextInput/TextInput2';
import { TextInputTouchable } from '../../TextInput/TextInputTouchable';
import { View } from 'react-native';
import { isWeb } from '../../../config/designSystem/Layout';
import { mainTypoRegular } from '../../../config/designSystem/typography';
import { observer } from 'mobx-react';
import { useBreakpointWidth } from '../../../hooks/useBreakpointWidth';
import { useOnMount } from '../../../hooks/useOnMount';
import { useRef } from 'react';
import { useStores } from '../../../hooks/useStores';

export interface AnswerFreeTextGenericProps {
  question: SnapshotOrInstance<IQuestionModel>;
}

const AnswerFreeTextGeneric : FC< AnswerFreeTextGenericProps> = ({
  question,
}) => {
  const { language, treeNav } = useStores();
  const labels = language.translate.MOBILE?.SESSION;
  const questionId = question._id;
  const questionKey = question.key;
  const value = treeNav.choices.pending?.freeText || '';

  const inputRef = useRef<TextInput>(null);

  const breakpointStyles = {
    container: {
      justifyContent: 'center',
      alignItems: 'center',
      marginHorizontal: 16,
    },
    contentWrapper: {
      marginVertical: 0,
      justifyContent: 'center',
      alignItems: 'center',
      md: {
        marginVertical: 150,
      },
    },
    textInput: {
      fontSize: 16,
      fontFamily: mainTypoRegular,
      color: COLORS.content.primary,
      lineHeight: 20,
      width:'100%',
    },
  } satisfies Record<string, StyleWithBreakpoints>;

  const styles = useBreakpointStyles(breakpointStyles);
  const width = useBreakpointWidth({
    md: 600,
    sm: 300,
  });

  useOnMount(() => {
    const previousValue = treeNav.choices.getFinalised(question._id)?.freeText;
    if (previousValue) {
      treeNav.choices.setPending({
        questionId,
        questionKey,
        freeText: previousValue,
      });
    }
  });

  const onChange = (newValue: string) => {
    treeNav.choices.updatePending({
      questionId,
      questionKey,
      freeText: newValue,
    });
  };
  return (
    <View
      style={styles.container}
    >
      <View
        style={styles.contentWrapper}
      >
        <Show when={isWeb}>
          <TextInput2
            value={value}
            onChangeText={onChange}
            label={labels?.PLACEHOLDER_FREE_TEXT}
            autoFocus={true}
            reference={inputRef}
            returnKeyType='done'
            textContentType='none'
            multiline={true}
            maxLength={500}
            widthInput={width}
          />
        </Show>
        <Show when={!isWeb}>
          <TextInputTouchable inputRef={inputRef} maxWidth={width}>
            <Feather
              name='pen-tool'
              size={16}
            />

            <TextInput
              style={styles.textInput}
              value={value}
              onChangeText={onChange}
              placeholder={labels?.PLACEHOLDER_FREE_TEXT}
              autoFocus={true}
              ref={inputRef}
              keyboardType='default'
              returnKeyType='done'
              multiline={true}
              numberOfLines={4}
              maxLength={500}
              blurOnSubmit={true}
            />
          </TextInputTouchable>
        </Show>



      </View>
    </View>
  );
};

export default observer(AnswerFreeTextGeneric);
